import { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProductionVehicle from './ProductionVehicle';
import { IRequest } from '../../../../../../Model/IRequest'
import { IProductionVehicle } from '../../../../../../Model/IProductionVehicle'
import { IReason } from '../../../../../../Model/IReason'
import RequisitionAction from '../../../../../../Store/Component/Requisition/RequisitionAction'
import { AttributeName, CONSTANTS } from "client/utils/constants";
import { initializeReason } from 'client/utils/RequisitionUtil';
import ConfirmationBee from "../../../../../assets/images/ConfirmationBee.svg";
import PriceInfoDispatch from 'Store/AssetManagement/PriceInfo/PriceInfoDispatch';
import { setPriceInfo } from 'Store/AssetManagement/PriceInfo/PriceInfoAction';
import { popupInitialData } from 'utils';
import { getRequistionDropDown, setRequistionDropDown } from 'Store/AssetManagement/RequisitionDropDown/RequisitionDropDownAction';


const ProductionVehicleContainer = (props: any) => {

  ///dispatch
  const dispatch = useDispatch();
  const dispatchPriceInfo = PriceInfoDispatch.dispatchGetPriceInfo(dispatch)

  const refreshToken=props.uniqueRefreshUUid;

  
  const initializeDropDowm = {
    text: "Select",
    value: "0",
    label: '',
    key: "",
    showVehicleCapacity: false
  }

const showInitialState = {
  showNoOfDoor: false,
  showUpfitOption: true,
  showVehicleCapacity: false,
  showDriveTrain: false,
  showFuelType: false,
  showVehicle: false,
  showSnowSetup: false
}

const initialDropDownValue = {
  noOfDoorDropDown: {},
  upfitOptionDropDown: {},
  vehicleCapacityDropDown: {},
  driveTrainDropDown: {},
  fuelTypeDropDown: {},
  vehicleDropDown:{},
  snowSetupDropDown:{}
}

  const [vehicleType, setVehicleType] = useState(initializeDropDowm);
  const [vehicleCapacity, setVehicleCapacities] = useState(initializeDropDowm);
  const [noOfDoors, setNoOfDoor] = useState(initializeDropDowm);
  const [upfitOption, setUpfitOption] = useState(initializeDropDowm);
  const [driveTrain, setDriveTrain] = useState(initializeDropDowm);
  const [snowSetup, setSnowSetup] = useState(initializeDropDowm);
  const [quantity, setQuantity] = useState(1);
  const [fuelType, setFuelType] = useState(initializeDropDowm);
  const ProductionFieldRef = useRef<any>([]);
  const [showDropDown, setShowDropDown] = useState<any>(showInitialState);
  const [dropDownValues, setDropDownValues] = useState<any>(initialDropDownValue);
  
  const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);
  const [showAddItem, setShowAddItem] = useState(false);

  const initializeProductionVehicleValidation = {
    VehicleError: '',
    VehicleCapacityError: '',
    NoOfDoorsError: '',
    UpfitOptionError: '',
    DriveTrainError: '',
    SnowSetupError: '',
    QtyError: ''
  }
  const [productionVehicleValidation, setProductionVehicleValidation] = useState<any>(initializeProductionVehicleValidation);
 

  ///selectors
  const { isAddItemclick,
    selectedRequisitionType,
    requestList,
    productionVehicleList,
    reasonList,
    priceInfo,
    editRequestDetails,
    isEditRequestClick,
    requisitionDropDown
  }: any = useSelector((state?: any) => ({
    selectedRequisitionType: state.RequisitionReducer.selectedRequisitionType,
    requestList: state.RequisitionReducer.requestList,
    productionVehicleList: state.RequisitionReducer.productionVehicleList,
    reasonList: state.RequisitionReducer.reasonList,
    priceInfo: state.PriceInfoReducer.priceInfo,
    isAddItemclick: state.RequisitionReducer.isAddItemclick,
    editRequestDetails: state.RequisitionReducer.editRequestDetails,
    isEditRequestClick: state.RequisitionReducer.isEditRequestClick,
    requisitionDropDown: state.RequisitionDropDownReducer.requisitionDropDown
  }));

  const [priceTemp, setPriceTemp] = useState<any>();
  useEffect(() => {    
    setPriceTemp(priceInfo)
    if(isAddItemclick){
    if (priceInfo === undefined || priceInfo === "" || priceInfo <= 0) {
      showPricePopup();
      dispatch(RequisitionAction.setIsAddItemclick(false))
      dispatch(setPriceInfo(""))
      return;
    }
    dispatch(RequisitionAction.setIsChangesOccured(true))
    props.setItemDetailComponent(true)
    dispatch(RequisitionAction.setShowItemDetails(true))

    //copy the global value      
    const requestListTemp = requestList?.length > 0 ? JSON.parse(JSON.stringify(requestList)) : [];
    const productionVehicleListTemp = productionVehicleList?.length > 0 ? JSON.parse(JSON.stringify(productionVehicleList)) : [];
    const reasonListTemp = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];

    //check duplicate
    const productionVehicle: IProductionVehicle = {
      requestIndex: 0,
        requestType: "",
        requestId: 0,
        price: "",
        productionVehicleIndex: 0,
        orderTypeId: selectedRequisitionType.orderRequestTypeId,
        orderSubTypeId: selectedRequisitionType.orderRequestSubTypeId,
        vehicleTypeId: vehicleType.value,
        vehicleType: vehicleType.text,
        showVehicleCapacity: vehicleType.showVehicleCapacity,
        vehicleCapacityId: vehicleCapacity.value,
        vehicleCapacity: vehicleCapacity.text,
        doorNosId: noOfDoors.value,
        doorNos: noOfDoors.text,
        upfitOption: upfitOption.text,
        upfitOptionId: upfitOption.value,
        driveTrain: driveTrain.text,
        driveTrainId: driveTrain.value,
        snowSetup: snowSetup.text,
        snowSetupId: snowSetup.value,
        quantity: quantity,
        isExistInCart: false,
        fuelType: fuelType.text != 'Select' ? fuelType.text : null,
        fuelTypeId: fuelType.value
    };

    let blnDuplicate = false;
    productionVehicleListTemp.forEach((item : any) => {
      if (vehicleType.showVehicleCapacity){
        if (item.vehicleType === productionVehicle.vehicleType
          && item.vehicleCapacity === productionVehicle.vehicleCapacity
          && item.doorNos === productionVehicle.doorNos
          && item.upfitOption === productionVehicle.upfitOption
          && item.driveTrain === productionVehicle.driveTrain
          && item.fuelType === productionVehicle?.fuelType
          && item.snowSetup === productionVehicle?.snowSetup) {
          blnDuplicate = true;
        }
      }
      if (!vehicleType.showVehicleCapacity){
        if (item.vehicleType === productionVehicle.vehicleType
          && item.doorNos === productionVehicle.doorNos
          && item.upfitOption === productionVehicle.upfitOption
          && item.driveTrain === productionVehicle.driveTrain
          && item.fuelType === productionVehicle?.fuelType
          && item.snowSetup === productionVehicle?.snowSetup) {
          blnDuplicate = true;
        }
      }
    });

    if (blnDuplicate) {
      let description = (
        <>
          <p>Item list Section already have this vehicle combination.</p>
          <p>
            Please try other.
          </p>
        </>
      )

      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "ALREADY EXISTS",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: description,
        primaryBtnText: "",
        outlineBtnText: "Ok",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclick: hideDialog,
        popupPrimarybtnOnclick: hideDialog
      });
      dispatch(RequisitionAction.setIsAddItemclick(false))
      dispatch(setPriceInfo(""))
      return;
    }

    //Request
    let nextRequestIndex = 0;
    requestListTemp.forEach((item : any) => {
      if (item?.requestIndex > nextRequestIndex) {
        nextRequestIndex = item?.requestIndex;
      }
    });
    nextRequestIndex = nextRequestIndex + 1;

    const request: IRequest = {
      requestIndex: nextRequestIndex,
      requestType: selectedRequisitionType.orderRequestType,
      showQuotePrice: false
    };
    requestListTemp.push(request);

    //Production Vehicle
   
    let nextProductionVehicleIndex = 0;
    productionVehicleListTemp.forEach((item : any) => {
      if (item.productionVehicleIndex > nextProductionVehicleIndex) {
        nextProductionVehicleIndex = item.productionVehicleIndex;
      }
      
    });
    nextProductionVehicleIndex = nextProductionVehicleIndex + 1;
   

    //set the index
    productionVehicle.requestIndex = request?.requestIndex;
    productionVehicle.requestType = request?.requestType;
    productionVehicle.productionVehicleIndex = nextProductionVehicleIndex;
    productionVehicle.quantity = quantity;
    ///Since the price is coming with the no of doors dropdown, assigned the price from key of ("NO of doors") noOfDoorsDropDownList.
    productionVehicle.price = priceInfo
    productionVehicleListTemp.push(productionVehicle);

    //Reason
    let nextReasonIndex = 0;
    reasonListTemp.forEach((item : any) => {
      if (item?.reasonIndex > nextReasonIndex) {
        nextReasonIndex = item?.reasonIndex;
      }
    });

    for (let i = 1; i <= quantity; i++) {
      nextReasonIndex = nextReasonIndex + 1;
      const reason: IReason = initializeReason(request, nextReasonIndex);
      reasonListTemp.push(reason);      
    }
    
    // Commented out resetting the Quantity - 189121 - Bug fix - Shrilatha
    // setQuantity(1); //Reset the count
    dispatch(RequisitionAction.setIRequest(requestListTemp))
    dispatch(RequisitionAction.setIProductionVehicle(productionVehicleListTemp))
    dispatch(RequisitionAction.setIReason(reasonListTemp))
    dispatch(RequisitionAction.setIsAddItemclick(false))
    dispatch(setPriceInfo(""))
  }
  }, [priceInfo]);

  useEffect(() => {
    dispatch(getRequistionDropDown({
      subTypeId: selectedRequisitionType.orderRequestSubTypeId,
      childAttributeName: AttributeName.UPFIT_OPTION,
      isProductionVehicle : true
    }))
    setShowAddItem(false)
    setShowDropDown(showInitialState)
    setDropDownValues(initialDropDownValue)
    if(editRequestDetails?.requestType === "" || editRequestDetails?.requestType === undefined){
      setVehicleType(initializeDropDowm);
      setVehicleCapacities(initializeDropDowm);
      setUpfitOption(initializeDropDowm);
      setDriveTrain(initializeDropDowm);
      setNoOfDoor(initializeDropDowm);
      setFuelType(initializeDropDowm)
      setSnowSetup(initializeDropDowm);
    }
    
    setQuantity(1);
  }, [selectedRequisitionType,refreshToken])

  useEffect(() => {
    if (requisitionDropDown?.hasOwnProperty('response')) {
      let dropDownTemp = requisitionDropDown?.response?.map((item: any) =>
        ({ text: item.text, value: item.value, label: item.text, key: item?.price ? item.price : "", showVehicleCapacity: item.selected ?? false })
      );
      if (requisitionDropDown?.childAttributeName === AttributeName.TRUCK_SIZE) {
        setShowDropDown({
          ...showDropDown,
          showVehicleCapacity: true
        })
        setDropDownValues({
          ...dropDownValues,
          vehicleCapacityDropDown: dropDownTemp
        })
        if(editRequestDetails?.requestType === CONSTANTS.PRODUCTION_VEHICLE){
          dispatch(getRequistionDropDown({
            subTypeId: selectedRequisitionType.orderRequestSubTypeId,
            childAttributeName: AttributeName.NO_OF_DOORS,
            upFit: editRequestDetails?.upfitOptionId,
            snowSetup: editRequestDetails?.snowSetupOptionId,
            vehicle: editRequestDetails?.vehicleTypeId,
            isProductionVehicle : true,
            isVehicleCapacity : editRequestDetails?.showVehicleCapacity,
            vehicleCapacity: editRequestDetails?.vehicleCapacityId,
          }))
        }
      } else if(requisitionDropDown?.childAttributeName === AttributeName.UPFIT_OPTION){
        setShowDropDown({
          ...showDropDown,
          showUpfitOption: true
        })
        setDropDownValues({
          ...dropDownValues,
          upfitOptionDropDown: dropDownTemp
        })
        if(editRequestDetails?.requestType === CONSTANTS.PRODUCTION_VEHICLE){
          dispatch(getRequistionDropDown({
            subTypeId: selectedRequisitionType.orderRequestSubTypeId,
            childAttributeName: AttributeName.SNOW_SETUP,
            upFit: editRequestDetails?.upfitOptionId,
            isProductionVehicle : true
          }))
        }
      } else if(requisitionDropDown?.childAttributeName === AttributeName.SNOW_SETUP){
        setShowDropDown({
          ...showDropDown,
          showSnowSetup: true
        })
        setDropDownValues({
          ...dropDownValues,
          snowSetupDropDown: dropDownTemp
        })
        if(editRequestDetails?.requestType === CONSTANTS.PRODUCTION_VEHICLE){
          dispatch(getRequistionDropDown({
            subTypeId: selectedRequisitionType.orderRequestSubTypeId,
            childAttributeName: AttributeName.VEHICLE_TYPE,
            upFit: editRequestDetails?.upfitOptionId,
            snowSetup: editRequestDetails?.snowSetupOptionId,
            isProductionVehicle : true
          }))
        }
      } else if(requisitionDropDown?.childAttributeName === AttributeName.NO_OF_DOORS){
        setShowDropDown({
          ...showDropDown,
          showNoOfDoor: true
        })
        setDropDownValues({
          ...dropDownValues,
          noOfDoorDropDown: dropDownTemp
        })
        if(editRequestDetails?.requestType === CONSTANTS.PRODUCTION_VEHICLE){
          dispatch(getRequistionDropDown({
            subTypeId: selectedRequisitionType.orderRequestSubTypeId,
            childAttributeName: AttributeName.DRIVE_TRAIN,
            upFit: editRequestDetails?.upfitOptionId,
            vehicle: editRequestDetails?.vehicleTypeId,
            isProductionVehicle : true,
            isVehicleCapacity : editRequestDetails?.showVehicleCapacity,
            vehicleCapacity: editRequestDetails?.vehicleCapacityId,
            noOfDoors: editRequestDetails.doorNosId,
          }))
        }
      } else if(requisitionDropDown?.childAttributeName === AttributeName.DRIVE_TRAIN){
        setShowDropDown({
          ...showDropDown,
          showDriveTrain: true
        })
        setDropDownValues({
          ...dropDownValues,
          driveTrainDropDown: dropDownTemp
        })
        if(editRequestDetails?.requestType === CONSTANTS.PRODUCTION_VEHICLE){
          dispatch(getRequistionDropDown({
            subTypeId: selectedRequisitionType.orderRequestSubTypeId,
            childAttributeName: AttributeName.FUEL_TYPE,
            driveTrain: editRequestDetails.driveTrainId,
            upFit: editRequestDetails?.upfitOptionId,
            snowSetup: editRequestDetails?.snowSetupOptionId,
            vehicle: editRequestDetails?.vehicleTypeId,
            isProductionVehicle : true,
            isVehicleCapacity : editRequestDetails?.showVehicleCapacity,
            vehicleCapacity: editRequestDetails?.vehicleCapacityId,
            noOfDoors: editRequestDetails.doorNosId,
          }))
        }
      } else if(requisitionDropDown?.childAttributeName === AttributeName.FUEL_TYPE){
        dropDownTemp.unshift({
          value: null,
          label: 'Select',
          text: 'Select',
        })
        setShowDropDown({
          ...showDropDown,
          showFuelType: true
        })
        setDropDownValues({
          ...dropDownValues,
          fuelTypeDropDown: dropDownTemp
        })
      } else if(requisitionDropDown?.childAttributeName === AttributeName.VEHICLE_TYPE){
        setShowDropDown({
          ...showDropDown,
          showVehicle: true
        })
        setDropDownValues({
          ...dropDownValues,
          vehicleDropDown: dropDownTemp
        })
        if(editRequestDetails?.requestType === CONSTANTS.PRODUCTION_VEHICLE){
          dispatch(getRequistionDropDown({
            subTypeId: selectedRequisitionType.orderRequestSubTypeId,
            childAttributeName: editRequestDetails?.showVehicleCapacity ? AttributeName.TRUCK_SIZE : AttributeName.NO_OF_DOORS,
            upFit: editRequestDetails?.upfitOptionId,
            snowSetup: editRequestDetails?.snowSetupOptionId,
            vehicle: editRequestDetails?.vehicleTypeId,
            isProductionVehicle : true,
            isVehicleCapacity : editRequestDetails?.showVehicleCapacity
          }))
        }
      }
      dispatch(setRequistionDropDown([]))
    }
  }, [requisitionDropDown])

  useEffect(() => {
    fieldFocus()
  }, [])

  const snowSetupOnChange = (selectedItem: any) => {
    setQuantity(1) // Reset Quantiy 
    setSnowSetup(selectedItem);
    if (selectedItem?.key !== null) {
      ProductionFieldRef?.current[4]?.focus();
    }

    dispatch(getRequistionDropDown({
      subTypeId: selectedRequisitionType.orderRequestSubTypeId,
      childAttributeName: AttributeName.VEHICLE_TYPE,
      upFit: upfitOption?.value,
      snowSetup: selectedItem.value,
      isProductionVehicle : true
    }))
    
    setShowDropDown({...showDropDown, showVehicle: false, showVehicleCapacity: false, showNoOfDoor: false, showDriveTrain: false, showFuelType: false})
    setShowAddItem(false)
    setVehicleType(initializeDropDowm)
    setVehicleCapacities(initializeDropDowm)
    setNoOfDoor(initializeDropDowm)
    setDriveTrain(initializeDropDowm)
    setFuelType(initializeDropDowm)
    
    const error = productionVehicleValidation;
    if (selectedItem.value !== null)
      error.SnowSetupError = "";
    else
      error.SnowSetupError = "Please select snow setup";
    setProductionVehicleValidation(error);

  }

  const vehicleOnChange = (e: any, selectedItem: any) => {
    setQuantity(1) // Reset Quantiy 
    setVehicleType(selectedItem);
    if(!selectedItem.showVehicleCapacity){
      setVehicleCapacities({text: 'Select Vehicle Capacity', value: "0", label: 'Select Vehicle Capacity', key: "", showVehicleCapacity: false})
    }else{
      setVehicleCapacities(initializeDropDowm)
    }
      setShowDropDown({...showDropDown, showVehicleCapacity: false, showNoOfDoor: false, showDriveTrain: false, showFuelType: false})
      setShowAddItem(false)
      setNoOfDoor(initializeDropDowm)
      setDriveTrain(initializeDropDowm)
      setFuelType(initializeDropDowm)
    dispatch(getRequistionDropDown({
      subTypeId: selectedRequisitionType.orderRequestSubTypeId,
      childAttributeName: selectedItem?.showVehicleCapacity ? AttributeName.TRUCK_SIZE : AttributeName.NO_OF_DOORS,
      upFit: upfitOption?.value,
      snowSetup: snowSetup?.value,
      vehicle: selectedItem.value,
      isProductionVehicle : true,
      isVehicleCapacity : selectedItem.showVehicleCapacity
    }))
    const error = productionVehicleValidation;
    if (selectedItem.value !== null)
      error.VehicleError = "";
    else
      error.VehicleError = "Please select vehicle";
    setProductionVehicleValidation(error);
    if (selectedItem?.key !== null) {
      ProductionFieldRef?.current[1]?.focus();
    }

  }

  const vehicleCapacityOnChange = (e: any, selectedItem: any) => {
    setVehicleCapacities(selectedItem);
      const error = productionVehicleValidation;
      if (selectedItem.value !== null){
        error.VehicleCapacityError = "";
        dispatch(getRequistionDropDown({
          subTypeId: selectedRequisitionType.orderRequestSubTypeId,
          childAttributeName: AttributeName.NO_OF_DOORS,
          upFit: upfitOption?.value,
          snowSetup: snowSetup?.value,
          vehicle: vehicleType.value,
          vehicleCapacity: selectedItem.value,
          isProductionVehicle : true,
          isVehicleCapacity : vehicleType.showVehicleCapacity
        }))
        setShowDropDown({...showDropDown, showNoOfDoor: false, showDriveTrain: false, showFuelType: false})
        setShowAddItem(false)
      setNoOfDoor(initializeDropDowm)
      setDriveTrain(initializeDropDowm)
      setFuelType(initializeDropDowm)
      }
      else
        error.VehicleCapacityError = "Please select vehicle capacity";
      setProductionVehicleValidation(error);
      if (selectedItem?.key !== null) {
        ProductionFieldRef?.current[2]?.focus();
      }
    setQuantity(1) // Reset Quantiy 
  }

  const noOfDoorsOnChange = (e: any, selectedItem: any) => {
    setNoOfDoor(selectedItem);
    if (selectedItem?.key !== null) {
      ProductionFieldRef?.current[3]?.focus();
    }
    const error = productionVehicleValidation;
    if (selectedItem.value !== null){
      dispatch(getRequistionDropDown({
        subTypeId: selectedRequisitionType.orderRequestSubTypeId,
        childAttributeName: AttributeName.DRIVE_TRAIN,
        upFit: upfitOption?.value,
        snowSetup: snowSetup?.value,
        vehicle: vehicleType.value,
        vehicleCapacity: vehicleCapacity.value,
        noOfDoors: selectedItem.value,
        isProductionVehicle : true,
        isVehicleCapacity : vehicleType.showVehicleCapacity
      }))
      setShowDropDown({...showDropDown, showDriveTrain: false, showFuelType: false})
      setShowAddItem(false)
      setDriveTrain(initializeDropDowm)
      setFuelType(initializeDropDowm)
      productionVehicleValidation.NoOfDoorsError = "";
    }
    else
      productionVehicleValidation.NoOfDoorsError = "Please select no of doors";
    setProductionVehicleValidation(error);
    setQuantity(1) // Reset Quantiy 
  }

  const upfitOptionOnChange = (selectedItem: any) => {
    setUpfitOption(selectedItem);
    if (selectedItem?.key !== null) {
      ProductionFieldRef?.current[7]?.focus();
    }
    const error = productionVehicleValidation;
    if (selectedItem.value !== null){
      dispatch(getRequistionDropDown({
        subTypeId: selectedRequisitionType.orderRequestSubTypeId,
        childAttributeName: AttributeName.SNOW_SETUP,
        upFit: selectedItem.value,
        isProductionVehicle : true
      }))
      setShowAddItem(false)
      setShowDropDown(showInitialState)
      setVehicleType(initializeDropDowm)
      setVehicleCapacities(initializeDropDowm)
      setNoOfDoor(initializeDropDowm)
      setDriveTrain(initializeDropDowm)
      setFuelType(initializeDropDowm)
      productionVehicleValidation.UpfitOptionError = "";
    }
    else
      productionVehicleValidation.UpfitOptionError = "Please select upfit option";
    setProductionVehicleValidation(error);
    setQuantity(1) // Reset Quantiy 
  }

  const driveTrainOnChange = (selectedItem: any) => {
    setDriveTrain(selectedItem);
    if (selectedItem?.key !== null) {
      ProductionFieldRef?.current[5]?.focus();
    }
    const error = productionVehicleValidation;
    if (selectedItem.value !== null){
      dispatch(getRequistionDropDown({
        subTypeId: selectedRequisitionType.orderRequestSubTypeId,
        childAttributeName: AttributeName.FUEL_TYPE,
        upFit: upfitOption?.value,
        snowSetup: snowSetup?.value,
        vehicle: vehicleType.value,
        vehicleCapacity: vehicleCapacity.value,
        noOfDoors: noOfDoors.value,
        driveTrain: selectedItem.value,
        isProductionVehicle : true,
        isVehicleCapacity : vehicleType.showVehicleCapacity
      }))
      setShowDropDown({...showDropDown, showFuelType: false})
      setFuelType(initializeDropDowm)
      setShowAddItem(true)
      productionVehicleValidation.DriveTrainError = "";
    }
    else
      productionVehicleValidation.DriveTrainError = "Please select drive train";
    setProductionVehicleValidation(error);
    setQuantity(1) // Reset Quantiy 
  }

  const fuelTypeOnChange = (selectedItem: any) => {
    setFuelType(selectedItem);
    setShowAddItem(true)
    if (selectedItem?.key !== null) {
      ProductionFieldRef?.current[6]?.focus();
    }
    const error = productionVehicleValidation;
    setProductionVehicleValidation(error);
    setQuantity(1) // Reset Quantiy 
  }

  const quantityIncrement = () => {
    let qty = parseInt(quantity.toString()) + 1;
    setQuantity(qty);
    productionVehicleValidation.QtyError = "";
  }

  const quantityDecrement = () => {
    if (parseInt(quantity.toString()) !== 0) {
      let qty = parseInt(quantity.toString()) - 1;
      setQuantity(qty);
      productionVehicleValidation.QtyError = "";
    }
  }

  const quantityOnChange = (e: any) => {
    //QtyError
    const error = productionVehicleValidation;
    if (isNaN(e.target.value.toString()) || parseInt(e.target.value) <= 0) {
      productionVehicleValidation.QtyError = "Please enter a valid quantity";
    
    } else {
      productionVehicleValidation.QtyError = "";
      setQuantity(e.target.value);
    }
    setProductionVehicleValidation(error);

   
  }

  const onBlur = () => {
    if (!quantity) {
      setQuantity(1);
    }
  }

  const validation: any = () => {
    let error = JSON.parse(JSON.stringify(productionVehicleValidation));

    if (vehicleType.label === undefined || vehicleType?.label?.toString()?.trim()?.length == 0 || vehicleType.label === null || vehicleType.label === "Select" || vehicleType.label === "Select Vehicle") {
      error.VehicleError = "Please select vehicle";
    } else {
      error.VehicleError = "";
    }
    if (vehicleType?.showVehicleCapacity) {
      if (vehicleCapacity.label === undefined || vehicleCapacity?.label?.toString()?.trim()?.length == 0 || vehicleCapacity.label === null || vehicleCapacity.label === 'Select' || vehicleCapacity.label === 'Select Vehicle Capacity') {
        error.VehicleCapacityError = "Please select vehicle capacity";
      } else {
        error.VehicleCapacityError = "";
      }
    }else{
      error.VehicleCapacityError = "";
    }
    if (noOfDoors.label === undefined || noOfDoors?.label?.toString()?.trim()?.length == 0 || noOfDoors.label === null || noOfDoors.label === "Select" || noOfDoors.label === "Select No Of Doors") {
      error.NoOfDoorsError = "Please select no of doors";
    } else {
      error.NoOfDoorsError = "";
    }

    if (upfitOption.label === undefined || upfitOption?.label?.toString()?.trim()?.length == 0 || upfitOption.label === null || upfitOption.label === "Select" || upfitOption.label === "Select Upfit Option") {
      error.UpfitOptionError = "Please select upfit option";
    } else {
      error.UpfitOptionError = "";
    }

    if (driveTrain.label === undefined || driveTrain?.label?.toString()?.trim()?.length == 0 || driveTrain.label === null || driveTrain.label === "Select" || driveTrain.label === "Select Drive Train") {
      error.DriveTrainError = "Please select drive train";
    } else {
      error.DriveTrainError = "";
    }

    if (snowSetup.label === undefined || snowSetup.label === "" || snowSetup.label === null || snowSetup.label === "Select" || snowSetup.label === "Select Snow Setup") {
      error.SnowSetupError = "Please select snow setup";
    } else {
      error.SnowSetupError = "";
    }

    setProductionVehicleValidation(error);
    return error;
  }

  const reset = () => {
    setVehicleType(initializeDropDowm);
    setVehicleCapacities(initializeDropDowm)
    setNoOfDoor(initializeDropDowm)
    setUpfitOption(initializeDropDowm)
    setDriveTrain(initializeDropDowm)
    setFuelType(initializeDropDowm)
    setSnowSetup(initializeDropDowm)
    setQuantity(1)
    setShowDropDown(showInitialState)
    setDropDownValues({
      noOfDoorDropDown: {},
      vehicleCapacityDropDown: {},
      driveTrainDropDown: {},
      fuelTypeDropDown: {},
      vehicleDropDown:{}
    })
    setShowAddItem(false)
  }

  const showPricePopup = () => {
    dispatch(setPriceInfo(""))
    let description = (
      <>
        <p>Pricing not available for this selection.</p>
        <p>
          Please select Non-Standard Equipment to request this vehicle.
        </p>
      </>
    )

    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "PRICE NOT AVAILABLE",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: description,
      primaryBtnText: "",
      outlineBtnText: "Ok",
      isSingleConfirmationBtn: true,
      popupOutlinebtnOnclick: () => { 
        if(!isEditRequestClick){
          reset(); 
        }
        hideDialog(); 
      },
    });
  }

  const addOnClick = () => {
    dispatch(RequisitionAction.setIsAddToCartClick(false));
    props.setItemDetailComponent(true)
    let productionVehicleValidationError = validation(vehicleType);
    let validToShowItemDetail = true;
    for (let key in productionVehicleValidationError) {
      if (productionVehicleValidationError[key]) {
         validToShowItemDetail = false;
         return validToShowItemDetail
      }
    }
    if (validToShowItemDetail) {
      dispatch(RequisitionAction.setIsAddItemclick(true))
      if (!vehicleType.showVehicleCapacity) {
        const requestObject = {
          subTypeId: selectedRequisitionType.orderRequestSubTypeId,
          vehicleType: vehicleType.text,
          vehicleCapacity: "",
          noOfDoors: noOfDoors.text,
          driveTrain: driveTrain.text,
          upfitOption: upfitOption.text,
          snowSetup: snowSetup.text,
          driverTitle: "",
          fuelType: fuelType.text != 'Select' ? fuelType.text : null
        }
        dispatchPriceInfo(requestObject);
      } else if (vehicleType.showVehicleCapacity) {
          const requestObject = {
            subTypeId: selectedRequisitionType.orderRequestSubTypeId,
            vehicleType: vehicleType.text,
            vehicleCapacity: vehicleCapacity.text,
            noOfDoors: noOfDoors.text,
            driveTrain: driveTrain.text,
            upfitOption: upfitOption.text,
            snowSetup: snowSetup.text,
            driverTitle: "",
            fuelType: fuelType.text != 'Select' ? fuelType.text : null
          }
          dispatchPriceInfo(requestObject);
      }
    }
  }

  const hideDialog = useCallback(
    () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
    []
  );


  //Edit request type

  useEffect(() => {
    if(editRequestDetails?.requestType === CONSTANTS.PRODUCTION_VEHICLE){
      fieldFocus()
      dispatch(RequisitionAction.setIsUpdateSuccessAlert(false))
      setShowAddItem(true)
      setShowDropDown({
        showNoOfDoor: true,
        showUpfitOption: true,
        showVehicleCapacity: true,
        showDriveTrain: true,
        showFuelType: true,
        showVehicle: true,
        showSnowSetup: true
      })
      setSnowSetup({
        text: editRequestDetails?.snowSetup, 
        value: `${editRequestDetails?.snowSetupId}`, 
        label: editRequestDetails?.snowSetup, 
        key: `${editRequestDetails?.snowSetupId}`,
        showVehicleCapacity: false
      })

      setVehicleType({text: editRequestDetails?.vehicleType, value: `${editRequestDetails?.vehicleTypeId}`, label: editRequestDetails?.vehicleType, key: `${editRequestDetails?.vehicleTypeId}`, showVehicleCapacity: editRequestDetails?.showVehicleCapacity })
      
      setVehicleCapacities({text: editRequestDetails?.vehicleCapacity, value: `${editRequestDetails?.vehicleCapacityId}`, label: editRequestDetails?.vehicleCapacity, key: `${editRequestDetails?.vehicleCapacityId}`, showVehicleCapacity: false})

      setNoOfDoor({text: editRequestDetails?.doorNos, value: `${editRequestDetails?.doorNosId}`, label: editRequestDetails?.doorNos, key: `${editRequestDetails?.doorNosId}`, showVehicleCapacity: false})

      setUpfitOption({text: editRequestDetails?.upfitOption, value: `${editRequestDetails?.upfitOptionId}`, label: editRequestDetails?.upfitOption, key: `${editRequestDetails?.upfitOptionId}`, showVehicleCapacity: false})

      setDriveTrain({text: editRequestDetails?.driveTrain, value: `${editRequestDetails?.driveTrainId}`, label: editRequestDetails?.driveTrain, key: `${editRequestDetails?.driveTrainId}`, showVehicleCapacity: false})
      
      setFuelType({text: editRequestDetails?.fuelType, value: `${editRequestDetails?.fuelTypeId}`, label: editRequestDetails?.fuelType, key: `${editRequestDetails?.fuelTypeId}`, showVehicleCapacity: false})
    }
  }, [editRequestDetails])

  const fieldFocus = () =>{
    ProductionFieldRef.current[0]?.focus()
  }

  const [isUpdateClick, setIsUpdateClick] = useState<any>(false)

  useEffect(() => {
    if(isUpdateClick){
      if (priceTemp === undefined || priceTemp === "" || priceTemp <= 0) {
        showPricePopup();
        return;
      }
      dispatch(RequisitionAction.setIsChangesOccured(true))
      props.setItemDetailComponent(true)
      dispatch(RequisitionAction.setShowItemDetails(true))
      
      const productionVehicleListTemp = productionVehicleList?.length > 0 ? JSON.parse(JSON.stringify(productionVehicleList)) : [];

      let blnDuplicate = false;
      productionVehicleListTemp.forEach((item : any) => {
        if (vehicleType.showVehicleCapacity && item?.requestIndex !== editRequestDetails?.requestIndex){
          if (item.vehicleType === vehicleType.text
            && item.vehicleCapacity === vehicleCapacity.text
            && item.doorNos === noOfDoors.text
            && item.upfitOption === upfitOption.text
            && item.snowSetup === snowSetup.text
            && item.driveTrain === driveTrain.text
            && item.fuelType === fuelType?.text) {
            blnDuplicate = true;
          }}
          if (!vehicleType.showVehicleCapacity && item?.requestIndex !== editRequestDetails?.requestIndex){
            if (item.vehicleType === vehicleType.text
              && item.doorNos === noOfDoors.text
              && item.upfitOption === upfitOption.text
              && item.snowSetup === snowSetup.text
              && item.driveTrain === driveTrain.text
              && item.fuelType === fuelType?.text) {
              blnDuplicate = true;
            }}
      });

      if (blnDuplicate) {
        let description = (
          <>
            <p>Item list Section already have this vehicle combination.</p>
            <p>
              Please try other.
            </p>
          </>
        )

        setPopupcontent({
          ...Popupcontent,
          titleImg: ConfirmationBee,
          title: "ALREADY EXISTS",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: description,
          primaryBtnText: "",
          outlineBtnText: "Ok",
          isSingleConfirmationBtn: true,
          popupOutlinebtnOnclick: hideDialog,
          popupPrimarybtnOnclick: hideDialog
        });
        dispatch(setPriceInfo(""))
        return;
      }

      productionVehicleListTemp?.map((item : any) => {
        if(item?.requestIndex === editRequestDetails?.requestIndex){      

          item.vehicleType = vehicleType.text;
          item.vehicleTypeId = vehicleType.value;
          item.vehicleCapacity = vehicleCapacity.text;
          item.vehicleCapacityId = vehicleCapacity.value;
          item.doorNos = noOfDoors.text;
          item.doorNosId = noOfDoors.value;
          item.upfitOption = upfitOption.text;
          item.snowSetup = snowSetup.text;
          item.snowSetupId = snowSetup.value;
          item.driveTrain = driveTrain.text;
          item.upfitOptionId = upfitOption.value;
          item.driveTrainId = driveTrain.value;
          item.price = priceTemp;
          item.fuelType = fuelType?.text != 'Select' ? fuelType.text : null;
          item.fuelTypeId = fuelType?.value;

        }
      })
      dispatch(RequisitionAction.setIsUpdateSuccessAlert(true))
      dispatch(RequisitionAction.setIProductionVehicle(productionVehicleListTemp))
      dispatch(RequisitionAction.setIsEditRequestClick(false))
      dispatch(RequisitionAction.setEditRequestDetails({}))
      // dispatch(RequisitionAction.setIsAddRequistionTypeClick(true))
      dispatch(setPriceInfo(""))
    }
    
  }, [priceInfo])

  const updateOnClick = () => {
    setIsUpdateClick(true)
    dispatch(RequisitionAction.setIsAddToCartClick(false));
    props.setItemDetailComponent(true)
    let productionVehicleValidationError = validation(vehicleType);
    let validToShowItemDetail = true;
    for (let key in productionVehicleValidationError) {
      if (productionVehicleValidationError[key]) {
        validToShowItemDetail = false
        return validToShowItemDetail
      }
    }

    if (validToShowItemDetail) {
      if (!vehicleType.showVehicleCapacity) {
        const requestObject = {
          subTypeId: selectedRequisitionType.orderRequestSubTypeId,
          vehicleType: vehicleType.text,
          vehicleCapacity: "",
          noOfDoors: noOfDoors.text,
          driveTrain: driveTrain.text,
          upfitOption: upfitOption.text,
          snowSetup: snowSetup.text,
          driverTitle: "",
          fuelType: fuelType.text != 'Select' ? fuelType.text : null
        }
        dispatchPriceInfo(requestObject);
      } else if (vehicleType.showVehicleCapacity) {
          const requestObject = {
            subTypeId: selectedRequisitionType.orderRequestSubTypeId,
            vehicleType: vehicleType.text,
            vehicleCapacity: vehicleCapacity.text,
            noOfDoors: noOfDoors.text,
            driveTrain: driveTrain.text,
            upfitOption: upfitOption.text,
            snowSetup: snowSetup.text,
            driverTitle: "",
            fuelType: fuelType.text != 'Select' ? fuelType.text : null
          }
          dispatchPriceInfo(requestObject);
      }

    } 
  }   
  
  const cancelEditRequestType = () => {
    dispatch(RequisitionAction.setEditRequestDetails({}))
    dispatch(RequisitionAction.setIsEditRequestClick(false))
  }
  
  return <ProductionVehicle
    vehicleOnChange={vehicleOnChange}
    vehicleCapacityOnChange={vehicleCapacityOnChange}
    noOfDoorsOnChange={noOfDoorsOnChange}
    upfitOptionOnChange={upfitOptionOnChange}
    selectedUpfitOption={upfitOption}
    driveTrainOnChange={driveTrainOnChange}
    snowSetupOnChange={snowSetupOnChange}
    selectedSnowSetup={snowSetup}
    selectedDriveTrain={driveTrain}
    quantityIncrement={quantityIncrement}
    quantityDecrement={quantityDecrement}
    selectedVehicleType={vehicleType}
    selectedVehicleCapacity={vehicleCapacity}
    selectedNoOfDoors={noOfDoors}
    selectedQuantity={quantity}
    addOnClick={addOnClick}
    ProductionFieldRef={ProductionFieldRef}
    productionVehicleValidation={productionVehicleValidation}
    hideDialog={hideDialog}
    Popupcontent={Popupcontent}
    quantityOnChange={quantityOnChange}
    onBlur={onBlur}
    updateOnClick={updateOnClick}
    isEditRequestClick={isEditRequestClick}
    cancelEditRequestType={cancelEditRequestType}
    fuelTypeOnChange={fuelTypeOnChange}
    selectedFuelType={fuelType}
    showDropDown = {showDropDown}
    dropDownValues = {dropDownValues}
    showAddItem = {showAddItem}
  />
}

export default ProductionVehicleContainer;